import { AlertCard } from "@dash/page";
import { useTheme } from "@emotion/react";
import Decimal from "decimal.js";
import React from "react";

import { useClientManager } from "@megaron/react-clients";
import { Uuid } from "@megaron/uuid";

type Props = {
  billToId: Uuid;
  orderNetTotal: Decimal;
};

export const CreditLimitAlert: React.FunctionComponent<Props> = (props) => {
  const query = useClientManager("crm").checkCustomerCredit().useQuery({
    customerId: props.billToId,
  });

  if (!query.data) return null;
  if (props.orderNetTotal.lte(query.data.limitExclVat)) return null;

  return (
    <AlertCard title="Przekroczono limit kredytu">
      <div>
        Limit kredytu netto: <strong>{query.data.limitExclVat.toFixed(2)} PLN</strong>
      </div>
      <div>Zaproponuj zmianę warunków handlowych lub poinformuj klienta o konieczności przedpłaty.</div>
    </AlertCard>
  );
};
